import { type AddressReadDto } from "@/config/apiClient";

export enum AddressDrawerTypeEnum {
  LIST = "LIST",
  FORM = "FORM",
}

export type AddressDrawerProps = {
  isOpen: boolean;
  type?: AddressDrawerTypeEnum;
  selectedAddresses: AddressReadDto[];
  addressToBeEdited?: Omit<AddressReadDto, "createdAt">;
  onOpenChange: () => void;
  onDeleteAddressCallback?: (
    address: Omit<AddressReadDto, "createdAt">
  ) => void;
  onSelectAddress: (addresses: AddressReadDto[]) => void;
};
